import NoindexHelmet from '@src/components/NoindexHelmet';
import { Error500Form } from '@src/features/error';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function Error500({ isTenant }: { isTenant: boolean }) {
  return (
    <>
      <NoindexHelmet />
      {isTenant ? (
        <TenantCenterCardLayout>
          <Error500Form isTenant={isTenant} />
        </TenantCenterCardLayout>
      ) : (
        <CompanyCenterCardLayout>
          <Error500Form isTenant={isTenant} />
        </CompanyCenterCardLayout>
      )}
    </>
  );
}

export default Error500;
